<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useStoreWebcam } from '@/composables/useStoreWebcam'

import CtaComponent from '../atoms/CtaComponent.vue'

export default defineComponent({
  name: 'ThePermissions',
  components: {
    CtaComponent
  },
  props: {
  },
  emits: [],
  setup (props, { emit }) {
    const { permissions } = useStoreWebcam()

    const checkPermission = computed(() => {
      if (permissions.value === 'granted') {
        return true
      } else if (permissions.value === 'prompt') {
        return true
      } else {
        return false
      }
    })

    const restartExperience = () => { window.location.reload() }

    return {
      restartExperience,
      checkPermission
    }
  }
})
</script>

<template>
  <div v-if="!checkPermission" class="modal-wrapper fixed top-0 left-0 h-lview w-full flex flex-col items-center justify-center px-2">
    <div class="modal-ctn max-w-100 flex flex-col gap-2 items-center justify-center px-4 pt-6 pb-2">
      <p class="body-2 text-center">It seems your browser is not allowed to start the experience. Try enabling the camera in your settings and restart.</p>
      <CtaComponent class="border-none underline p-0" @click="restartExperience()">Restart the Experience</CtaComponent>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.modal-wrapper {
  z-index: $z-modal;
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 43.7%);
}

.modal-ctn {
  border: 2px solid $c-white;
  border-radius: 20px;
  backdrop-filter: $backdrop-modal;
  background: rgb(255,255,255);
  background: $c-card-gradient;
  background-color: rgba(237, 242, 245, 30%);
  box-shadow: inset 3px 3px 4px #eaeaeace, inset -3px -1px 11px #EAEAEA;
}

</style>
